<template>
  <el-drawer
    title="Select Beneficiary"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <div v-if="isLoading">
      <spinner />
    </div>

    <div v-else>
      <div class="mx-4 overflow-scroll h-screen">
        <div>
          <div
            class="bg-primary text-white w-full rounded-xl cursor-pointer py-4 text-xs font-extralight items-center flex justify-center"
            @click="openAddBeneficiaryDrawer"
          >
            <i class="text-base px-2 el-icon-plus"></i>
            <p>Add New Beneficiary</p>
          </div>
          <!-- search for a beneficiary -->
          <div class="mt-5">
            <el-input class="w-full" v-model="search" placeholder="Search">
              <i
                slot="prefix"
                class="el-input__icon el-icon-search text-xl text-root-2 mt-3 pl-2"
              ></i>
            </el-input>
          </div>
        </div>
        <div class="mt-10" v-if="drawerBeneficiaries.length">
          <div
            v-for="(beneficiary, index) in drawerBeneficiaries"
            :key="index"
            @click="
              selectBeneficiary({
                ...beneficiary.details,
                id: beneficiary.id
              })
            "
          >
            <div
              v-if="beneficiary.details.bankDetails"
              class="border border-root-2 p-4 flex items-start rounded-lg mt-4 cursor-pointer"
            >
              <div class="mr-4">
                <el-avatar
                  class="bg-subtle text-primary border-main lg:text-xl flex items-center justify-center"
                  >{{ avatarIcon(beneficiary) }}</el-avatar
                >
              </div>
              <div class="flex items-center justify-between w-full capitalize">
                <div>
                  <p class="text-black-10 font-bold text-base capitalize">
                    {{
                      beneficiary.nickname ||
                      beneficiary.details.bankDetails.accountName ||
                      '-'
                    }}
                  </p>
                  <p class="text-black-2 text-sm font-normal capitalize my-1">
                    {{ accountProviderTitle }}:
                    {{ beneficiary.details.bankDetails.bankName || '-' }}
                  </p>
                  <p class="text-black-2 text-sm font-normal">
                    {{ accountTitle }}:
                    {{ beneficiary.details.bankDetails.accountNumber || '-' }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <empty-beneficiary-state
            @addNewBeneficiary="openAddBeneficiaryDrawer"
          />
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
import getSavedBeneficiaries from '@/mixins/bridge.js'
import bulkPayout from '@/mixins/bulkPayout.js'
import { ACCOUNT_DETAILS_TITLES } from '@/utils/constants.js'

export default {
  mixins: [getSavedBeneficiaries, bulkPayout],
  name: 'Drawer',
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    currencyType: {
      type: String,
      default: () => 'NGN'
    },
    beneficiaryType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      breakpoints,
      search: '',
      isLoading: false,
      showAddBeneficiariesDrawer: false,
      payload: {
        page: 1,
        size: 5
      }
    }
  },
  components: {
    Spinner: () => import('@/components/v2/app/Spinner.vue'),
    EmptyBeneficiaryState: () =>
      import('@/components/v2/bridge/drawers/EmptyBeneficiaryState.vue')
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    accountProviderTitle () {
      return ACCOUNT_DETAILS_TITLES[this.beneficiaryType || 'banks'].provider
    },
    accountTitle () {
      return ACCOUNT_DETAILS_TITLES[this.beneficiaryType || 'banks'].account
    },
    drawerBeneficiaries () {
      const isMno = this.beneficiaryType === 'mno'
      return this.filterSavedBeneficiaries.filter((beneficiary) => {
        const isMobileMoney = beneficiary.details?.bankDetails?.isMobileMoney
        if (isMno) {
          return isMobileMoney === 'yes' || isMobileMoney === 'true'
        } else {
          return this.filterSavedBeneficiaries
        }
      })
    }
  },
  methods: {
    avatarIcon (beneficiary) {
      return beneficiary.nickname
        ? beneficiary.nickname.charAt(0).toUpperCase()
        : beneficiary.details.bankDetails.accountName.charAt(0).toUpperCase()
    },
    handleClose () {
      this.$emit('closeDrawer')
    },
    openAddBeneficiaryDrawer () {
      this.$emit('showAddBeneficiariesDrawer')
      this.handleClose()
    },
    selectBeneficiary (beneficiary) {
      this.$store
        .dispatch('bulkPayout/setBeneficiaryDetails', beneficiary)
        .then(() => {
          this.handleClose()
        })
    },
    openModal (arg) {
      this[arg] = true
    },
    closeModal (arg) {
      this[arg] = false
    }
  },
  watch: {
    currencyType: function (newValue) {
      this.getPayoutBeneficiaries(newValue)
    },
    deep: true
  },
  mounted () {
    this.getPayoutBeneficiaries(this.currencyType)
  }
}
</script>
<style scoped>
>>> .el-input__inner {
  padding-left: 3rem !important;
}
</style>
